import { z } from 'zod';

export const schema = z.object({ personalStory: z.string().optional() }).default({ personalStory: '' });
